var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "healthcareSolutions"
  }, [_c("section", {
    staticClass: "healthcareSolutions-banner",
    style: {
      background: `url(${_vm.imageUrl}) no-repeat center 0px`,
      backgroundSize: "cover"
    }
  }, [_c("Banner", {
    attrs: {
      imageUrl: _vm.imageUrl,
      title: _vm.bannerTitle,
      description: _vm.bannerText
    }
  })], 1), _c("ProgramComposition"), _c("section", {
    staticClass: "healthcareSolutions_advantages"
  }, [_c("div", {
    staticClass: "ads-main"
  }, [_c("Title", {
    staticClass: "title",
    attrs: {
      title: "应用场景"
    }
  }), _c("div", {
    staticClass: "ads-wrapper"
  }, [_c("div", {
    staticClass: "left"
  }, _vm._l(_vm.leftItems, function (item, index) {
    return _c("div", {
      key: index,
      class: ["left_item", {
        "left_item--active": _vm.activeIndex === index
      }],
      on: {
        click: function ($event) {
          return _vm.changeActive($event, index);
        }
      }
    }, [_c("img", {
      staticClass: "left-bg",
      attrs: {
        src: item.bgImg,
        alt: "bgimg"
      }
    }), _c("img", {
      staticClass: "title-img",
      attrs: {
        src: _vm.activeIndex === index ? item.activeImg : item.img,
        alt: "left-img"
      }
    }), _c("p", {
      staticClass: "litem-title"
    }, [_vm._v(_vm._s(item.title))])]);
  }), 0), _c("div", {
    staticClass: "right"
  }, [_vm.activeIndex === 0 ? _c("div", {
    staticClass: "right-content1"
  }, [_c("div", {
    staticClass: "item-left-voice"
  }, [_c("img", {
    attrs: {
      src: _vm.healthImgUrl,
      alt: ""
    }
  })]), _c("div", {
    staticClass: "item-right-text"
  }, [_c("div", {
    staticClass: "text-introduction"
  }, [_vm._v(" 人工智能消化内镜辅助质量控制系统，提供全面、便捷的消化内镜检查检验辅助功能，助力临床医生实现高标准、高质量的消化道内镜诊断 ")]), _c("div", {
    staticClass: "core-functions"
  }, [_c("p", {
    staticClass: "core-title"
  }, [_vm._v("核心功能")]), _c("ul", {
    staticClass: "core-list"
  }, _vm._l(_vm.coreFunctionList[0], function (item, index) {
    return _c("li", {
      key: index,
      staticClass: "list-item"
    }, [_c("img", {
      attrs: {
        src: item.img,
        alt: ""
      }
    }), _c("span", {
      staticClass: "desc"
    }, [_vm._v(_vm._s(item.desc))])]);
  }), 0)])])]) : _vm.activeIndex === 1 ? _c("div", {
    staticClass: "right-content2"
  }, [_c("div", {
    staticClass: "item-top-voice"
  }, [_c("div", {
    staticClass: "item-top-left"
  }, [_c("img", {
    attrs: {
      src: _vm.scenariosImgUrl,
      alt: ""
    }
  })]), _c("div", {
    staticClass: "item-top-right"
  }, [_vm._v(" 智能骨折辅助分析系统是一款辅助急诊（放射）医生快速识别CT影像骨折状态的软件。系统基于深度学习技术，识别患者肋骨CT序列图像完成肋骨曲面重建，生成易识别的肋骨曲面展开图并提示异常部位，辅助医生快速、精准完成肋骨骨折诊断，避免发生漏诊。 ")])]), _c("div", {
    staticClass: "item-bottom-core"
  }, [_c("div", {
    staticClass: "core-title"
  }, [_vm._v("核心功能")]), _c("ul", {
    staticClass: "core-list"
  }, _vm._l(_vm.coreFunctionList[1], function (item, index) {
    return _c("li", {
      key: index,
      staticClass: "list-item"
    }, [_c("img", {
      attrs: {
        src: item.img,
        alt: ""
      }
    }), _c("div", {
      staticClass: "list-text"
    }, [_c("span", {
      staticClass: "list-item-title"
    }, [_vm._v(_vm._s(item.title))]), _c("div", {
      staticClass: "list-item-content"
    }, [_c("p", {
      style: {
        lineHeight: index === 2 ? "14px" : "18px"
      }
    }, [_vm._v(_vm._s(item.desc1))]), _c("p", [_vm._v(_vm._s(item.desc2))]), item.desc3 ? _c("p", [_vm._v(_vm._s(item.desc3))]) : _vm._e()])])]);
  }), 0)])]) : _vm.activeIndex === 2 ? _c("div", {
    staticClass: "right-content3"
  }, [_c("div", {
    staticClass: "item-top-text"
  }, [_vm._v(" 智能医疗语音助手：智能医疗语音助手是一款基于人工智能语音技术、自然语言处理技术等核心技术的语音助手。他可以代替人工，帮助医院或机构完成预约提醒、患者宣教、随访外呼、客服接听等一系列任务，节约医护资源，提供更优质高效的服务。 ")]), _c("div", {
    staticClass: "item-bottom-core"
  }, [_c("div", {
    staticClass: "core-title"
  }, [_vm._v("核心功能")]), _c("div", {
    staticClass: "core-content"
  }, [_c("div", {
    staticClass: "core-hospitals"
  }, [_c("div", {
    staticClass: "title"
  }, [_vm._v("医院机构")]), _c("ul", {
    staticClass: "core-list"
  }, _vm._l(_vm.coreFunctionList[2], function (item, index) {
    return _c("li", {
      key: index,
      staticClass: "list-item"
    }, [_c("div", {
      staticClass: "list-content-left"
    }, [_c("img", {
      attrs: {
        src: item.img,
        alt: ""
      }
    }), _c("p", {
      staticClass: "list-title"
    }, [_vm._v(_vm._s(item.title))])]), _c("div", {
      staticClass: "list-content-right"
    }, [_c("p", [_vm._v(_vm._s(item.desc1))]), _c("p", [_vm._v(_vm._s(item.desc2))]), _c("p", [_vm._v(_vm._s(item.desc3))]), _c("p", [_vm._v(_vm._s(item.desc4))])])]);
  }), 0)]), _c("div", {
    staticClass: "core-healthcare"
  }, [_c("div", {
    staticClass: "title"
  }, [_vm._v("卫健系统")]), _c("ul", {
    staticClass: "core-list"
  }, _vm._l(_vm.coreFunctionList[3], function (item, index) {
    return _c("li", {
      key: index,
      staticClass: "list-item"
    }, [_c("div", {
      staticClass: "list-content-left"
    }, [_c("img", {
      attrs: {
        src: item.img,
        alt: ""
      }
    }), _c("p", {
      staticClass: "list-title"
    }, [_vm._v(_vm._s(item.title))])]), _c("div", {
      staticClass: "list-content-right"
    }, [_c("p", [_vm._v(_vm._s(item.desc1))]), _c("p", [_vm._v(_vm._s(item.desc2))]), _c("p", [_vm._v(_vm._s(item.desc3))]), _c("p", [_vm._v(_vm._s(item.desc4))])])]);
  }), 0)])])])]) : _vm._e()])])], 1)]), _c("Cases", {
    attrs: {
      showCase: true,
      showTitle: false,
      source: "healthcare"
    }
  }), _c("Appointment2")], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };